import { render } from "./AboutPage.vue?vue&type=template&id=34a3692c&ts=true"
import script from "./AboutPage.vue?vue&type=script&lang=ts"
export * from "./AboutPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__